(function () {
  var supportsIO = 'IntersectionObserver' in window;

  function reveal() {
    var els = document.querySelectorAll('[data-kv-reveal]:not(.kv-revealed)');
    if (!els.length) return;

    if (!supportsIO) {
      els.forEach(function (el) { el.classList.add('kv-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kv-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  // Re-scan when sections are added/edited live in the theme editor
  document.addEventListener('shopify:section:load', reveal);
})();
